module.exports = __webpack_public_path__ + "h5/img/global_mg.788a31c4.png";